// extracted by mini-css-extract-plugin
export default {"button":"styles_button__SnSXV","primary":"styles_primary__F4gpV","secondary":"styles_secondary__vQCxj","disabled":"styles_disabled__wjqsK"};